import React from "react";
import pic1 from "../../assets/images/Home/Pic1.jpeg";
import pic2 from "../../assets/images/Home/Pic2.webp";
import pic3 from "../../assets/images/Home/Pic3.webp";
import pic4 from "../../assets/images/Home/Pic4.webp";
import pic5 from "../../assets/images/Home/Pic5.webp";
import pic6 from "../../assets/images/Home/Pic6.jpeg";
import pic8 from "../../assets/images/Home/Picn8.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Leadership = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const leaders = [
    {
      id: 1,
      name: {
        English: "Shri. Acharya Devvrat",
        मराठी: "श्री. आचार्य देवव्रत",
      },
      title: {
        English: "Hon'ble Governor",
        मराठी: "मा. राज्यपाल",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic1,
    },
    {
      id: 2,
      name: {
        English: "Shri. Devendra Fadnavis",
        मराठी: "श्री.देवेंद्र फडवणीस ",
      },
      title: {
        English: "Hon'ble Chief Minister",
        मराठी: "माननीय मुख्यमंत्री",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic2,
    },
    {
      id: 3,
      name: {
        English: "Shri. Eknath Shinde",
        मराठी: "श्री. एकनाथ शिंदे",
      },
      title: {
        English: "Hon'ble Deputy Chief Minister",
        मराठी: "माननीय उपमुख्यमंत्री",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic3,
    },
    {
      id: 4,
      name: {
        English: "Shri. Ajit Pawar",
        मराठी: "श्री. अजित पवार",
      },
      title: {
        English: "Hon'ble Deputy Chief Minister",
        मराठी: "माननीय उपमुख्यमंत्री",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic4,
    },
    {
      id: 5,
      name: {
        English: "Adv.Shri. Ashish Shelar",
        मराठी: "ॲड.श्री. आशिष शेलार",
      },
      title: {
        English: "Hon'ble Minister Department of Cultural Affairs",
        मराठी: "माननीय मंत्री, सांस्कृतिक कार्य विभाग",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic5,
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
    },
    {
      id: 6,
      name: {
        English: "Dr. Kiran Kulkarni",
        मराठी: "डॉ. किरण कुलकर्णी",
      },
      title: {
        English:
          "Hon’ble Secretary,Department of Cultural Affairs",
        मराठी:
          "माननीय सचिव, सांस्कृतिक कार्य विभाग",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic6,
    },

    {
      id: 7,
      name: {
        English: "Dr. Tejas Garge",
        मराठी: "डॉ. तेजस गर्गे",
      },
      title: {
        English: "Director Directorate of Archaeology and Museums",
        मराठी: "संचालक, पुरातत्त्व व वस्तुसंग्रहालय संचालनालय",
      },
      department: {
        English: "Government of Maharashtra",
        मराठी: "महाराष्ट्र शासन",
      },
      image: pic8,
    },
  ];

  const content = {
    English: {
      title: "Leadership",
      breadcrumb: {
        home: "HOME",
        page: "LEADERSHIP",
      },
      heading1: `Mission`,
      heading2: `Vision`,
      heading3: `Schemes`,
      heading4: `Awards`,
    },
    मराठी: {
      title: "नेतृत्व",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "नेतृत्व",
      },
      heading1: `श्री. च. पो. राधाकृष्णन.`,
      subheading: `मा. राज्यपाल महाराष्ट्र शासन`,
      heading2: `दृष्टी`,
      heading3: `योजना`,
      heading4: `पुरस्कार`,
    },
  };
  const t = content[selectedLang];

  return (
    <div className="py-16">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-8">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Leadership List */}
      <div
        className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-20 py-10 pt-28 space-y-20"
        style={{ margin: "10px" }}
      >
        {leaders.map((leader,index) => (
          <div
            key={leader.id}
            className={`flex flex-col md:flex-row items-center gap-6 md:gap-14 ${index % 2 === 1 ? "md:flex-row-reverse" : ""
              }`}
          >
            {/* Image */}
            <div className="w-80 h-80 flex-shrink-0">
              <img
                src={leader.image}
                alt={leader.name}
                className="w-full h-full object-cover rounded-xl shadow-lg"
              />
            </div>

            {/* Text Content */}
            <div className="flex flex-col items-center text-center max-w-3xl mx-auto px-4">
  <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#111827]">
    {leader.name[selectedLang]}
  </h2>
  <p className="text-base sm:text-lg text-[#4B5563] mt-2">
    {leader.title[selectedLang]}
  </p>
  <p className="text-base sm:text-lg text-[#4B5563] mb-3">
    {leader.department[selectedLang]}
  </p>
</div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default Leadership;
